export default "__VITE_ASSET__BDpVOuU5__"